import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-master-editar-perfil-cancelamento',
  templateUrl: './master-editar-perfil-cancelamento.component.html',
  styleUrls: ['./master-editar-perfil-cancelamento.component.scss']
})
export class MasterEditarPerfilCancelamentoComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<MasterEditarPerfilCancelamentoComponent>) { }

  ngOnInit() {
  }

}
